import { CustomerState } from "../customer.slice.ts";
import { PayloadAction } from "@reduxjs/toolkit";
import { LivingSituationRequest } from "../../../../orchestrator-api-client";

export const submitLivingSituationReducer = (
  state: CustomerState,
  action: PayloadAction<LivingSituationRequest>,
) => {
  state.living = {
    ...action.payload,
    homeStatus: action.payload.homeStatus ?? "",
  };
};
